import startTime from '../util/startTime';

export default {
  init() {
    // JavaScript to be fired on all pages
    startTime();
    window.trackBrokerLink = function(brokerName) {
      gtag('event', 'click', {
      'event_category': 'outclick',
      'event_label': brokerName,
      'transport_type': 'beacon',
      'event_callback': function(){}
      });

// Log a Conversion for Goal 1
window._paq = window._paq || [];
window._paq.push(['trackGoal', 1]);

if(brokerName == 'eToro') {
	// Log a Conversion for Goal 2 (eToro)
	window._paq = window._paq || [];
	window._paq.push(['trackGoal', 2]);
}

    }
  },
  finalize() {

    equalHeights('.toplist-small .broker-logo');

    var $ab = $('.admin-bar');

    if ($ab.length > 0) {
      $('.nav-primary .dropdown-menu').toggleClass('transform-admin');
    } else {
      $('.nav-primary .dropdown-menu').toggleClass('transform');
    }

/*    $('.nav-primary .dropdown').hover(function() {
      $(this).toggleClass('show');
      $(this).children('ul').toggleClass('show');
      //$('.nav-primary .dropdown .dropdown-menu').toggleClass('show');
    });
*/
    $('.btn-bars', '.nav-primary-responsive').on('click', function() {
      $(this).siblings('div').toggleClass('d-block');
      $(this).parent('.nav-primary-responsive').toggleClass('show-nav');
    });

    $('[data-bs-toggle="tooltip"]').tooltip();

    $('.regulators .more, .hq .more').on("click", function() {
      $(this).parent().html(function(){
        return $(this).data("text");
      });
    });

    // JavaScript to be fired on all pages, after page specific JS is fired

    $('#btn-grid-mode').on('click', function(e) {
      $(this).toggleClass('selected').prop("disabled", function (_, val) { return ! val; });
      $('#btn-list-mode').toggleClass('selected').prop("disabled", function (_, val) { return ! val; });
      $('section.articles').animate({
        opacity: 0
      }, function() {
        $(this).toggleClass('article-grid').promise().done(function() {
            $('.articles article > div.row').css('height', 'auto');
            equalHeights('.articles article > div.row');
        });
        $(this).animate({opacity: 1});
      });
      e.preventDefault();
    });

    $('#btn-list-mode').on('click', function(e) {
      $(this).toggleClass('selected').prop("disabled", function (_, val) { return ! val; });
      $('#btn-grid-mode').toggleClass('selected').prop("disabled", function (_, val) { return ! val; });
      $('section.articles').animate({
        opacity: 0
      }, function() {
        $(this).toggleClass('article-grid').promise().done(function() {
            $('.articles article > div.row').css('height', 'auto');
            equalHeights('.articles article > div.row');
        });
        $(this).animate({opacity: 1});
      });
      e.preventDefault();
    });

    jQuery('a[href="#"]').on('click', function(e) {
      e.preventDefault();
    });

    $('#postLimit', '.bar').on('change', function(e) {
      
      document.cookie = 'set_post_limit=' + e.target.value + ';';
      var data = {'action': 'set_post_limit', 'value': e.target.value };
      $.post(ajax_url, data, function() {
        $('#loading-overlay').fadeIn();
        $('#category-select').submit();
      });
    });

  },
};

export function equalHeights(selector, updated_selector) {
  if (updated_selector === undefined) {
    updated_selector = selector;
    }

    if ($(selector).length === 0) {
      return false;
    }

    var height = 0;
    $(selector).each(function(){
      height = Math.max( height, $(this).outerHeight() );
    });

    var maxHeight = $(updated_selector).css('max-height');
    maxHeight = maxHeight.slice(0, maxHeight.length-2);

    if (height > maxHeight ) {
      height = maxHeight;
    }

    $(updated_selector).outerHeight(height);
}



// WEBPACK FOOTER //
// ./scripts/routes/common.js